type IconProps = React.SVGProps<SVGSVGElement>;

const Globe: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.0779 15.9724L14.9886 12.8422C14.8994 12.7874 14.7997 12.7518 14.6959 12.7378L12.5566 12.4494C12.396 12.4278 12.2326 12.4587 12.0911 12.5377C11.9495 12.6167 11.8374 12.7393 11.7714 12.8874L10.4871 15.7691C10.4274 15.9031 10.4083 16.0517 10.4322 16.1965C10.456 16.3412 10.5219 16.4758 10.6215 16.5836L12.384 18.4899C12.4639 18.5764 12.5223 18.6804 12.5545 18.7936C12.5868 18.9068 12.592 19.026 12.5696 19.1415L12.2106 20.9974M6.08927 5.2131L5.25074 7.19588C5.17598 7.37268 5.17184 7.57141 5.23919 7.75116L6.31646 10.6263C6.36058 10.744 6.43358 10.8488 6.52877 10.9309C6.62395 11.0131 6.73826 11.07 6.86118 11.0964L8.87024 11.5282C8.98172 11.5522 9.08627 11.6012 9.17594 11.6717C9.2656 11.7421 9.33803 11.8321 9.38771 11.9347L9.74449 12.6718C9.80589 12.7986 9.90178 12.9056 10.0212 12.9804C10.1406 13.0553 10.2786 13.095 10.4196 13.095H11.6789M14.293 3.29517L15.168 4.86252C15.2507 5.01069 15.2807 5.18253 15.2532 5.34997C15.2256 5.51741 15.1421 5.67056 15.0162 5.78438L12.4933 8.06602C12.4505 8.10475 12.4033 8.1384 12.3528 8.16631L11.2051 8.80009C11.0941 8.86139 10.9694 8.89355 10.8426 8.89355H8.84144C8.69387 8.89355 8.54958 8.93708 8.42663 9.0187C8.30369 9.10032 8.20755 9.2164 8.15026 9.3524L7.36959 11.2057M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Globe;
